<template>
  <div>
    <div class="d-flex flex-row">
      <img v-if="imageUrl" :src="imageUrl" :class="`me-${small ? 1 : 3} rounded`" :width="imageSize" :height="imageSize" style="object-fit:cover" alt="" />
      <div class="d-flex flex-column justify-content-around">
        <h6 v-if="title" class="mb-0">{{ title }}</h6>
        <a :href="safeHref(displayUrl)" target="_blank" class="text-decoration-none text-dark fw-bold small" rel="noopener noreferrer">
          {{ displayUrl }} <i class="bi-box-arrow-up-right"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { safeHref } from '@/safeRendering';
import {Listing} from "@/models/Listing";
import { cityRepository } from "@/data";

export default {
  props: {
    cityId: String,
    url: String,
    small: Boolean,
    publicView: Boolean,
    preExistingListing: Listing
  },
  data() {
    return {
      derivedListing: null
    };
  },
  mounted() {
    this.refresh();
  },
  watch: {
    url() {
      this.refresh();
    }
  },
  methods: {
    safeHref,

    async refresh() {
      if (this.publicView) { this.derivedListing = null; return; }
      if (!this.preExistingListing) {
        let id = null;
        if (this.airbnbId) {
          id = `airbnb_${this.airbnbId}`;
        } else if (this.vrboId) {
          id = `vrbo_${this.vrboId}`;
        } else if (this.flipKeyId) {
          // TODO
        }
        if (id) {
          let city = await cityRepository.loadCity(this.cityId);
          this.derivedListing = await Listing.one(city, id);
        } else {
          this.derivedListing = null;
        }
      }
    }
  },
  computed: {
    listing() {
      return this.preExistingListing || this.derivedListing;
    },
    imageSize() {
      return this.small ? 48 : 64;
    },
    title() {
      return this.listing?.title;
    },
    imageUrl() {
      return this.listing?.primaryImage;
    },
    displayUrl() {
      return this.listing?.url || this.url;
    },
    airbnbId() {
      return (this.url.match(/https:\/\/(.*\.)?airbnb\.com\/rooms\/(\d+).*/) || [])[2];
    },
    vrboId() {
      return (this.url.match(/https:\/\/.*\.vrbo\.com\/([\da-zA-Z]+).*/) || [])[1];
    },
    flipKeyId() {
      return (this.url.match(/https:\/\/.*\.flipkey\.com\/properties\/(\d+).*/) || [])[1];
    }
  }
}
</script>
